import { css, unsafeCSS } from 'lit-element';
import { litStyle } from 'lit-element-style';


export const formStyles = litStyle(css`

  /* Form styling elements */

  form .errors,
  .form .errors {
    margin-bottom: 20px;
    font-size: 13px;
    color: #900;
  }

  form .error,
  .form .error {
    margin-bottom: 10px;
    font-size: 13px;
    color: #900;
  }

  form .field,
  .form .field {
    display: block;
    margin-bottom: 15px;
  }

  form .field:last-child,
  .form .field:last-child {
    margin-bottom: 0;
  }

  form .field .error,
  .form .field .error {
    margin-bottom: 5px;
    font-size: 13px;
    color: #900;
  }

  form .field .label,
  .form .field .label {
    text-transform: uppercase;
    color: #444;
    font-size: 12px;
    font-weight: 600;
  }

  form .field .input,
  .form .field .input {
    margin-top: 5px;
    margin-bottom: 10px;
  }

  form .field .input input,
  .form .field .input input {
    width: 100%;
    max-width: 450px;
  }

  @media screen and (max-width: 500px) {

    form, .form,
    fieldset, .fieldset {
      max-width: none;
    }

    fieldset, .fieldset {
      padding: 10px;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }

  }



  /* Input fields */

  input[type=text],
  input[type=email],
  input[type=password],
  input[type=date],
  input[type=number],
  input[type=tel],
  input[type=url],
  select {
    box-sizing: border-box;
    height: 30px;
    border: 1px #BBB solid;
    border-radius: 3px;
    padding: 3px 15px;
    box-shadow: none;
    outline: none;
    background: #FFF;
    color: ${unsafeCSS(_themeData.text_color)};
  }

  input[type=text]:focus,
  input[type=email]:focus,
  input[type=password]:focus,
  input[type=date]:focus,
  input[type=number]:focus,
  input[type=tel]:focus,
  input[type=url]:focus,
  select:focus {
    box-shadow: inset 0 0 10px #DDD;
  }

  input[type=text][disabled],
  input[type=email][disabled],
  input[type=password][disabled],
  input[type=date][disabled],
  input[type=number][disabled],
  input[type=tel][disabled],
  input[type=url][disabled],
  select[disabled] {
    color: ${unsafeCSS(_themeData.light_text_color)};
    background-color: #EFEFEF;
    cursor: not-allowed;
  }

  select {
    padding-right: 30px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15"><path fill="rgb(100, 100, 100)" d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg>');
    background-position: right 11px center;
    background-repeat: no-repeat;
  }

  select:-moz-focusring {
    /* This removes the dotted outline in Firefox, see:
     * http://notes.jerzygangi.com/how-to-remove-the-dotted-border-from-around-select-tags-in-firefox/
     */
    color: transparent;
    text-shadow: 0 0 0 #000;
  }

  input[validate][type=text]:invalid,
  input[validate][type=email]:invalid,
  input[validate][type=password]:invalid,
  input[validate][type=date]:invalid,
  input[validate][type=number]:invalid,
  input[validate][type=tel]:invalid,
  input[validate][type=url]:invalid,
  select[validate]:invalid {
    border-color: red;
    box-shadow: 0 0 3px red;
  }

  @media screen and (max-width: 500px) {

    input[type=text],
    input[type=email],
    input[type=password],
    input[type=date],
    input[type=number],
    input[type=tel],
    input[type=url],
    select {
      height: 40px;
    }

  }

`);
